import { render } from "./brandIndex.vue?vue&type=template&id=7cfad072"
import script from "./brandIndex.vue?vue&type=script&lang=js"
export * from "./brandIndex.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__